<template>
  <div>
    <div>
      <!-- <div>{{ value }}</div>
      <div>{{ getTime30() }}</div> -->
      <!-- {{params.WeekOpenTime}} -->
      <!-- <van-divider/> -->
      <!-- len:{{ params.OpenTime }} -->
      <!-- {{ now }} /<br /> -->
      <!-- <div>{{ columns }}</div> -->

      <!-- {{orderer}} -->
      <!-- <div>{{columns}}</div> -->
      <!-- {{ params.OrderTimes }} -->

      <van-tabs v-model="orderer.potype" type="card">
        <van-tab title="外帶">
          <el-card shadow="never" :body-style="{ padding: '0px' }" style="margin: 1rem">
            <van-field
              v-model="orderer.name"
              name="姓名"
              label="姓名"
              placeholder="
              訂購人名稱"
              maxlength="10"
            />

            <van-field
              v-model="orderer.tel"
              name="電話"
              label="電話"
              type="tel"
              placeholder="手機號碼"
              maxlength="10"
            />

            <van-field
              readonly
              clickable
              name="calendar"
              :value="orderer.date + ' ' + orderer.time"
              label="取餐時間"
              placeholder="取餐時間"
              @click="showOrderTimePick"
            />
          </el-card>
        </van-tab>

        <!-- [外送] -->
        <van-tab title="外送" v-if="params.Ship">
          <el-card shadow="never" :body-style="{ padding: '0px' }" style="margin: 1rem">
            <van-field
              v-model="orderer.name"
              name="姓名"
              label="姓名"
              placeholder="取餐人名稱"
              maxlength="10"
            />
            <van-field
              v-model="orderer.tel"
              name="電話"
              label="電話"
              placeholder="手機號碼"
              maxlength="10"
            />
            <van-field
              v-model="orderer.address"
              name="地址"
              label="地址"
              placeholder="輸入地址"
              maxlength="20"
            />

            <!-- <van-field
              readonly
              clickable
              name="calendar"
              :value="orderer.date"
              label="選擇日期"
              placeholder="選擇日期"
              @click="showDatePick"
              v-if="params.PickDate && params.OpenTime.length == 0"
            />

            <van-field
              readonly
              clickable
              name="datetimePicker"
              :value="orderer.time"
              label="指定時間"
              placeholder="選擇時間"
              @click="showTimePick()"
              v-if="params.OpenTime.length == 0"
            >
            </van-field> -->

            <van-field
              readonly
              clickable
              name="calendar"
              :value="orderer.date + ' ' + orderer.time"
              label="指定時間"
              placeholder="指定時間"
              @click="showOrderTimePick"
            />
            <div style="color: red; margin: 1rem; font-size: 0.8rem">
              {{ params.ShipNote }}
            </div>
          </el-card>
        </van-tab>
      </van-tabs>

      <!-- <div>選擇時間 {{ orderer.time }}</div>
      <div v-if="params.timeb != '' && params.timeb != undefined">
        <span>點餐時間 {{ params.timeb }}~{{ params.timee }}</span>
      </div> -->
      <!-- <div>點餐時間 {{ params.timeb }}~{{ params.timee }}</div>
      <div>取餐時間 {{ params.shiptimeb }}~{{ params.shiptimee }}</div> -->

      <van-popup v-model="frmTime.visible" position="bottom">
        <van-datetime-picker
          type="time"
          @confirm="onConfirm"
          @cancel="onCancel"
          v-model="value"
          :filter="filter"
        />
        <!-- <van-datetime-picker
          type="time"
          @confirm="onConfirm"
          @cancel="onCancel"
          v-model="value"
          :filter="filter"
          :min-hour="minHour"
          :max-hour="maxHour"
        /> -->
      </van-popup>

      <van-popup v-model="frmOpenTime.visible" position="bottom">
        <van-picker
          show-toolbar
          title="取餐時間"
          :columns="columns"
          @confirm="onOpenTimeConfirm"
          @cancel="onOpenTimeCancel"
          @change="onOpenTimeChange"
        />
      </van-popup>
      <van-calendar v-model="frmDate.visible" @confirm="onDateConfirm" />
    </div>
  </div>
</template>

<style scoped>
.qty {
  font-size: 2em;
}
.el-button {
  font-size: 2rem;
}
.van-tag {
  margin: 0 0 0 0.2rem;
}
.van-row {
  margin: 0 0 1rem 0;
}
</style>

<script>
// import list from "./json/list.json";
export default {
  name: "Orderer",
  props: {
    msg: String,
    list: Object,
    orderer: Object,
    params: Object,
    now: Object,
  },

  data() {
    return {
      // qty: 1,
      tel: "",
      text: "",
      digit: "",
      number: "",
      password: "",
      active: 0,
      // orderer: {"name":"","tel":"","time":"","address":"","remark":""},
      value: "",
      frmTime: { visible: false },
      frmDate: { visible: false },
      frmOpenTime: { visible: false },
      now30: "",
      minHour: 0,
      maxHour: 23,
      txt: "",
      columns: [],
    };
  },

  beforeMount: function () {
    this.init();
  },
  methods: {
    init() {
      setInterval(() => {
        // var dt = new Date();
        // var h = dt.getHours();
        // this.now = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
        // var time = this.getTime30();
        // this.now30 = time;
      }, 1000);
    },
    filter(type, options) {
      if (type === "minute") {
        return options.filter((option) => option % 5 === 0);
      }
      return options;
    },
    onConfirm(time) {
      var app = this;
      if (!this.isShipTime(time)) {
        app.$dialog.alert({
          message:
            "指定時間須在取餐範圍時間<br>" +
            this.params.shiptimeb +
            "~" +
            this.params.shiptimee,
        });
        return;
      }
      this.orderer.time = time;
      this.frmTime.visible = false;
    },
    onDateConfirm(date) {
      var app = this;
      var yy = date.getFullYear();
      var mm = Number(date.getMonth()) + 1;
      var dd = date.getDate();
      var ymd = yy + "/" + mm + "/" + dd;
      app.orderer.date = ymd;
      app.frmDate.visible = false;
    },
    onOpenTimeConfirm(date) {
      var app = this;
      var time = date[1];
      if (time.length == 5) {
        app.orderer.date = date[0];
        app.orderer.time = date[1];
      } else {
        app.orderer.date = "";
        app.orderer.time = "";
      }
      // alert(date);
      app.frmOpenTime.visible = false;
    },
    onOpenTimeCancel() {
      var app = this;
      app.frmOpenTime.visible = false;
    },
    isShipTime: function (time) {
      if (time == "" || time == undefined) {
        return true;
      }
      if (this.params.shiptimeb == undefined) {
        return true;
      }
      var timeb = {};
      var timee = {};
      var hh = Number(time.substr(0, 2));
      var mm = Number(time.substr(3, 2));

      timeb.hh = Number(this.params.shiptimeb.substr(0, 2));
      timeb.mm = Number(this.params.shiptimeb.substr(3, 2));
      timee.hh = Number(this.params.shiptimee.substr(0, 2));
      timee.mm = Number(this.params.shiptimee.substr(3, 2));

      if (timee.hh > timeb.hh) {
        //沒有跨日
        if (hh < timeb.hh) {
          return false;
        }

        if (hh > timee.hh) {
          return false;
        }

        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }

        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      } else if (timee.hh < timeb.hh) {
        //跨日營業

        if (hh < timeb.hh && hh > timee.hh) {
          return false;
        }

        if (hh > timee.hh && hh < timeb.hh) {
          return false;
        }

        if (hh == timeb.hh) {
          if (mm < timeb.mm) {
            return false;
          }
        }

        if (hh == timee.hh) {
          if (mm > timee.mm) {
            return false;
          }
        }
      }
      return true;
    },
    // isShipTime: function (time) {
    //   if (time == "" || time == undefined) {
    //     return true;
    //   }
    //   var timeb = {};
    //   var timee = {};
    //   var hh = time.substr(0, 2);
    //   var mm = time.substr(3, 2);
    //   // alert(time);
    //   timeb.hh = Number(this.params.shiptimeb.substr(0, 2));
    //   timeb.mm = Number(this.params.shiptimeb.substr(3, 2));
    //   timee.hh = Number(this.params.shiptimee.substr(0, 2));
    //   timee.mm = Number(this.params.shiptimee.substr(3, 2));

    //   if (hh < timeb.hh) {
    //     return false;
    //   }

    //   if (hh > timee.hh) {
    //     return false;
    //   }

    //   if (hh == timeb.hh) {
    //     if (mm < timeb.mm) {
    //       return false;
    //     }
    //   }

    //   if (hh == timee.hh) {
    //     if (mm > timee.mm) {
    //       return false;
    //     }
    //   }
    //   return true;
    // },

    setOrderer: function () {
      var app = this;
      app.$http
        .post("./setOrderer", { orderer: this.orderer })
        .then((response) => {
          console.log(response.data);
          this.closeOrderer();
        })
        .catch(function (error) {
          app.$dialog.alert({
            message: error,
          });
        });
    },

    showTimePick: function () {
      this.frmTime.visible = true;
    },
    showDatePick: function () {
      // var date = [];
      // var time = this.getTimeArray();
      // let date1 = this.dateAdd(1);
      // let date2 = this.dateAdd(2);
      // let date3 = this.dateAdd(3);
      // date.push(date1);
      // date.push(date2);
      // date.push(date3);

      // this.columns = [
      //   // 第一列
      //   {
      //     values: date,
      //     defaultIndex: 1,
      //   },
      //   // 第二列
      //   {
      //     values: time,
      //     defaultIndex: 1,
      //   },
      // ];
      this.frmDate.visible = true;
    },

    showOrderTimePick: function () {
      var app = this;
      let times = app.params.OrderTimes;
      let data = [];
      times.forEach((date) => {
        let ymd = date.ymd;
        let row = {};
        row.text = ymd;
        row.children = [];

        date.times.forEach((t) => {
          let row1 = {};
          row1.text = t.time;
          row1.count = t.count;
          row1.disabled = false;
          let y = ymd.toString().substr(0, 4);
          let m = Number(ymd.toString().substr(5, 2)) - 1;
          let d = ymd.toString().substr(8, 2);
          let hh = t.time.toString().substr(0, 2);
          let mm = t.time.toString().substr(3, 2);
          // alert( y  + " " +  m  + " " +  d  + " " +  hh + " " +  mm);
          let dt = new Date(y, m, d, hh, mm);
          let now = new Date();
          if (dt < app.dateAdd(now, app.params.SetupTime)) {
            row1.text = t.time + " 訂滿";
            row1.disabled = true;
          }

          if (app.params.LimitCount > 0) {
            if (row1.count >= app.params.LimitCount) {
              row1.text = t.time + " 訂滿";
              row1.disabled = true;
            }
          }

          row.children.push(row1);
        });

        if (row.children.length == 0) {
          row.text += " (公休)";
        }

        data.push(row);
      });

      app.columns = data;
      // alert("showOrderTimePick");
      app.frmOpenTime.visible = true;
      // var isVaild = false;
      // for (let i = 0; i < data.length; i++) {
      //   for (let j = 0; j < data[i].children.length; j++) {
      //     if (!data[i].children[j].disabled) {
      //       isVaild = true;
      //       break;
      //     }
      //   }
      // }
      // if (isVaild) {
      //   app.frmOpenTime.visible = true;
      // } else {
      //   app.$dialog.alert({
      //     message: "今日已休息",
      //   });
      // }
    },
    showOpenTimePick: function () {
      var app = this;
      let opentime = app.params.OpenTime;
      let datetime = [];
      for (let i = 0; i < opentime.length; i++) {
        let ymd = opentime[i].ymd;
        let row = {};
        let times = [];
        let y = ymd.toString().substr(0, 4);
        let m = Number(ymd.toString().substr(5, 2)) + 1;
        let d = ymd.toString().substr(8, 2);
        if (m < 10) {
          m = "0" + m;
        }
        row.text = y + "/" + m + "/" + d;
        times = app.getTimesByDate(ymd);
        row.children = times;
        var isVaild = false;
        for (let j = 0; j < times.length; j++) {
          if (!times[j].disabled) {
            isVaild = true;
            break;
          }
        }
        if (isVaild == false) {
          row.disabled = true;
          // row.text += "(休息)";
        }

        datetime.push(row);
      }
      app.columns = datetime;

      isVaild = false;
      for (let i = 0; i < datetime.length; i++) {
        for (let j = 0; j < datetime[i].children.length; j++) {
          if (!datetime[i].children[j].disabled) {
            isVaild = true;
            break;
          }
        }
      }
      if (isVaild) {
        app.frmOpenTime.visible = true;
      } else {
        app.$dialog.alert({
          message: "今日已休息",
        });
      }
    },
    getTimesByDate: function (date) {
      var app = this;
      let opentime = app.params.OpenTime;
      let times = [];
      for (let i = 0; i < opentime.length; i++) {
        let ymd = opentime[i].ymd;
        if (date == ymd) {
          for (let j = 0; j < opentime[i].hm.length; j++) {
            let hm = opentime[i].hm[j];
            let y = ymd.toString().substr(0, 4);
            let m = ymd.toString().substr(5, 2);
            let d = ymd.toString().substr(8, 2);
            let hh = hm.toString().substr(0, 2);
            let mm = hm.toString().substr(3, 2);
            let dt = new Date(y, m, d, hh, mm);
            let now = new Date();
            let row = {};
            row.text = hm;
            if (dt < app.dateAdd(now, app.params.SetupTime)) {
              row.disabled = true;
            }
            // row.text = y + "," + m + "," + d + "," + hh + "," + mm;
            times.push(row);
          }
        }
      }
      return times;
    },
    // getTimeArray: function (date) {
    //   console.log(date);
    //   var time = [];

    //   for (let i = 8; i < 22; i++) {
    //     let hh = i;
    //     if (hh < 10) {
    //       hh = "0" + i;
    //     }

    //     for (let j = 0; j < 60; j += 15) {
    //       let mm = j;
    //       if (mm < 10) {
    //         mm = "0" + j;
    //       }
    //       time.push(hh + ":" + mm);
    //     }
    //   }
    //   return time;
    // },
    // dateAdd: function (days) {
    //   var today = new Date();
    //   today.setDate(today.getDate() + days);
    //   var yy = today.getFullYear();
    //   var mm = today.getMonth() + 1;
    //   var dd = today.getDate();
    //   var ymd = yy + "/" + mm + "/" + dd;
    //   return ymd;
    // },
    closeOrderer: function () {
      this.frmOrderer.visible = false;
    },
    onCancel: function () {
      this.frmTime.visible = false;
      this.orderer.time = "";
    },
    getMaxHour: function () {},
    getMinHour: function () {},
    getTime30() {
      var dt = new Date();
      dt.setTime(dt.getTime() + 30 * 60 * 1000);

      var hour = dt.getHours();
      var min = dt.getMinutes();

      while (min % 5 != 0) {
        min++;
        if (min >= 60) {
          hour++;
          min = 0;
          if (hour == 24) {
            hour == 0;
          }
        }
      }

      var row = {};
      row.hour = hour;
      row.min = min;
      // if (this.params.shiptimee != "" && this.params.shiptimee != undefined) {
      //   this.maxHour = Number(this.params.shiptimee);
      // }
      return row;
    },
    dateAdd(datetime, min) {
      var dt = new Date();
      dt.setTime(datetime.getTime() + min * 60 * 1000);
      return dt;
    },
  },
};
</script>
